import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

export default function ConfirmDeleteDialog(props) {
    function handleCancel() {
        props.onClose(false);
    }

    function handleDelete() {
        props.onClose(true);
    }

    return (
        <Dialog
            onClose={props.inProgress ? undefined : handleCancel}
            aria-labelledby="confirm-delete-dialog-title"
            open={props.open}
            fullWidth
            maxWidth="xs"
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 3,
                        overflow: "hidden",
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        color: "error.main",
                        backgroundColor: "rgba(211, 47, 47, 0.09)",
                    }}
                >
                    <DeleteOutlineIcon />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        id="confirm-delete-dialog-title"
                        variant="h5"
                        component="h2"
                        sx={{ lineHeight: 1.1 }}
                    >
                        {props.title}
                    </Typography>
                    {props.detail && (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                mt: 0.5,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {props.detail}
                        </Typography>
                    )}
                </Box>
                <IconButton
                    aria-label="Close delete confirmation"
                    onClick={handleCancel}
                    disabled={props.inProgress}
                    sx={{ mt: -0.75, mr: -1 }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent
                dividers
                sx={{
                    p: { xs: 2, sm: 2.5 },
                    backgroundColor: "background.default",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1.25,
                        p: { xs: 1.5, sm: 2 },
                        borderRadius: 2.5,
                        border: "1px solid",
                        borderColor: "rgba(211, 47, 47, 0.18)",
                        backgroundColor: "background.paper",
                    }}
                >
                    <WarningAmberOutlinedIcon
                        sx={{
                            mt: 0.1,
                            flexShrink: 0,
                            color: "error.main",
                        }}
                    />
                    <Box>
                        <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 800 }}
                        >
                            {props.message}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 0.4 }}
                        >
                            {props.supportingMessage ||
                                "This action cannot be undone."}
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 1.5 }}>
                <Button
                    onClick={handleCancel}
                    color="inherit"
                    disabled={props.inProgress}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleDelete}
                    color="error"
                    variant="contained"
                    disableElevation
                    disabled={props.inProgress}
                    startIcon={<DeleteOutlineIcon />}
                >
                    {props.inProgress ? "Deleting…" : "Delete"}
                </Button>
            </DialogActions>
            {props.inProgress && <LinearProgress color="error" />}
        </Dialog>
    );
}
